import { useEffect, useState } from "react";

// Countdown cycle: 00:17:34, restarts automatically when it reaches zero.
const DURATION_MS = (17 * 60 + 34) * 1000;
const START = Date.now();

function remainingMs(): number {
  const elapsed = Date.now() - START;
  return DURATION_MS - (elapsed % DURATION_MS);
}

export function useCountdown() {
  const [ms, setMs] = useState<number>(remainingMs);

  useEffect(() => {
    const id = window.setInterval(() => setMs(remainingMs()), 250);
    return () => window.clearInterval(id);
  }, []);

  const total = Math.ceil(ms / 1000);
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;

  return {
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

function pad(n: number): string {
  return String(n).padStart(2, "0");
}
